import axios from 'axios'
import Cookies from 'js-cookie'
import queryString from 'query-string'
import { actionTypes } from '../constants'

export const fetchVenues = query => (dispatch, getState) => {
  const state = getState()
  if (queryString.stringify(query) === queryString.stringify(state.router.query)) {
    if (state.venue.wasFetched) {
      return
    }
  }
  dispatch({
    type: actionTypes.VENUES_ARE_FETCHING,
  })
  axios.get('/api/filter', {
    params: {
      ...query,
    },
  }).then((res) => {
    dispatch({
      payload: {
        venues: res.data.venues,
      },
      type: actionTypes.VENUES_WERE_FETCHED,
    })
    if (Cookies.get('y') !== undefined) {
      window.scrollTo(0, Cookies.get('y'))
      Cookies.remove('y')
    }
  })
}

export const venueMarkerWasClicked = (_id) => ({
  payload: {
    _id,
  },
  type: actionTypes.VENUE_MARKER_WAS_CLICKED,
})
